export default __webpack_public_path__ + "static/media/caen12.83d43461.jpg";